import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

export interface ProviderDetail {
  id?: number;
  customFieldsGroups?: unknown[];
  [key: string]: unknown;
}

export interface ProviderGetResponse {
  result?: ProviderDetail;
}

/** API Globalvision para proveedores en Services (/services/proveedor). */
@Injectable({
  providedIn: 'root',
})
export class ProviderServiceApi {
  constructor(private http: HttpClient) {}

  private authHeaders(): HttpHeaders {
    return new HttpHeaders().set('Token', localStorage.getItem('access_token') || '');
  }

  getProvider() {
    return this.http.get(`${environment.apiUrl}/globalvision/provider`, {
      headers: this.authHeaders(),
    });
  }

  getProviderAll() {
    return this.http.get(`${environment.apiUrl}/globalvision/provider/suggest`, {
      headers: this.authHeaders(),
    });
  }

  getCustomField(): Observable<unknown> {
    return this.http.post(
      `${environment.apiUrl}/globalvision/customfield/suggest`,
      { type: 'provider' },
      { headers: this.authHeaders() }
    );
  }

  async validateIfExist(provider: { customFields: unknown[]; id?: number }): Promise<boolean> {
    const exist: { result?: boolean } = await this.http
      .post(`${environment.apiUrl}/globalvision/provider/exist`, provider, {
        headers: this.authHeaders(),
      })
      .toPromise();
    return !!exist?.result;
  }

  create(provider: unknown) {
    return this.http.post(`${environment.apiUrl}/globalvision/provider/create`, provider, {
      headers: this.authHeaders(),
    });
  }

  getProviderId(id: number) {
    return this.http.post(
      `${environment.apiUrl}/globalvision/provider/get/${id}`,
      { type: 'provider' },
      { headers: this.authHeaders() }
    );
  }

  async getProviderById(id: number): Promise<ProviderGetResponse> {
    return this.http
      .post<ProviderGetResponse>(
        `${environment.apiUrl}/globalvision/provider/get/${id}`,
        { type: 'provider' },
        { headers: this.authHeaders() }
      )
      .toPromise();
  }

  updateProvider(_id: number, payload: unknown) {
    return this.http.post(`${environment.apiUrl}/globalvision/provider/update`, payload, {
      headers: this.authHeaders(),
    });
  }
}
